const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');

module.exports = class TextLabel extends Builder {
    constructor(title, properties) {
        super('formElement_TextLabel', title, properties);
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
